export function formatFileSize(bytes: number): string {
	if (bytes < 1024) return `${bytes} B`;
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const MIME_TYPE_MAP: Record<string, string> = {
	"application/pdf": "PDF",
	"image/jpeg": "JPG",
	"image/png": "PNG",
	"image/gif": "GIF",
	"application/msword": "DOC",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document":
		"DOCX",
};

export function getFileExtension(mimeType: string, fileName: string): string {
	if (MIME_TYPE_MAP[mimeType]) {
		return MIME_TYPE_MAP[mimeType];
	}
	return fileName.split(".").pop()?.toUpperCase() || "FILE";
}
